// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceInfo_root__u7dxY","rootIsValid":"PriceInfo_rootIsValid__TATCg","rootWrapper":"PriceInfo_rootWrapper__73KGp"};